import BidButton from '../../../elements/BidButton/BidButton'
import BidInput from '../../../elements/BidInput/BidInput'
import BidConditionsDropdown from '@components/BidConditionsDropdown/BidConditionsDropdown'
import BidGridIcon from '../../../elements/BidGridIcon/BidGridIcon'
import BidListViewIcon from '../../../elements/BidListViewIcon/BidListViewIcon'
import { useEffect } from 'react'
import { filterStateType } from '@components/AuctionDetails/useFilter'
import BackToFilteredAuctions from './BackToFilteredAuctions'

const Filters = ({
  auction,
  conditions,
  filter,
  handlers,
  isListView,
  setIsListView,
}: any) => {
  const { itemConditionIds, itemSearchKeywords }: filterStateType = filter

  const setLocalStorage = () => {
    let visitedAuctions = window.localStorage.getItem('visitedAuctions')

    if (visitedAuctions) {
      window.localStorage.setItem(
        'visitedAuctions',
        JSON.stringify(
          Object.assign(JSON.parse(visitedAuctions), {
            [auction.id]: 1,
          })
        )
      )
    } else {
      window.localStorage.setItem(
        'visitedAuctions',
        JSON.stringify({ [auction.id]: 1 })
      )
    }
  }

  useEffect(() => {
    setLocalStorage()
  }, [])

  return (
    <div className="md:z-20 bg-white p-4 xl:w-full grid grid-cols-1 md:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-6 lg:sticky lg:top-30">
      <div className="hidden lg:block">
        <BackToFilteredAuctions />
      </div>

      <div className="col-span-1 w-full">
        <BidInput
          inputValue={itemSearchKeywords}
          setInputValue={handlers.searchInput}
          bindInputValue
          theme="blue"
          placeholder="Search Auction"
          searchIcon
        />
      </div>

      <BidConditionsDropdown
        conditions={conditions}
        activeConditions={itemConditionIds}
        handleCondition={handlers.condition}
      />
      <div className="flex gap-2 w-full">
        <BidButton
          label="Clear Filters"
          theme="blue-light"
          callBack={handlers.clearAllFilters}
          width={'full'}
          className="grow"
        />
        <div className="hidden xl:block shrink">
          <div className="mb-1">
            <BidGridIcon
              isListView={isListView}
              setIsListView={setIsListView}
            />
          </div>
          <BidListViewIcon
            isListView={isListView}
            setIsListView={setIsListView}
          />
        </div>
      </div>
    </div>
  )
}

export default Filters
